export default "__VITE_ASSET__CLZMPyS2__"